import React from "react";
import { Introduction } from "../../Components/Introduction/Introduction";
import { About } from "../../Components/About/About";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar/Sidebar";
import { Work } from "../../Components/Work/Work";
import { Experience } from "../../Components/Experience/Experience";
import { Contact } from "../../Components/Contact/Contact";
import Footer from "../../Components/Footer/Footer";
import ReactParticle from "../../Components/ReactParticle/ReactParticle";
import Header from "../../Components/Header/Header";

const HomeScreen = () => {
  return (
    <div className=" h-full w-full">
      <Sidebar></Sidebar>
      <Navbar />
      <Introduction />
      <About />
      <Experience />
      <Work />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomeScreen;
